export interface IClickChainRequestable {
  clickChainedObjectPrivateId: number;
  isClickChained(clickChainIdentifier: string): boolean;
}

export function instanceOfIClickChainRequestable(instance: any): instance is IClickChainRequestable {
  return instance
    && (instance.clickChainedObjectPrivateId !== undefined)
    && (instance.isClickChained !== undefined);
}
